import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyBSnM0osEyCSu1oR-hB1n33dh5jabNnDOc",
    authDomain: "conference-cms-react.firebaseapp.com",
    databaseURL: "https://conference-cms-react.firebaseio.com",
    projectId: "conference-cms-react",
    storageBucket: "conference-cms-react.appspot.com",
    messagingSenderId: "1007219974729",
    appId: "1:1007219974729:web:639a733ebe0916f86f9598"
  };

  firebase.initializeApp(firebaseConfig);

  const database = firebase.database()
  const auth = firebase.auth()

  export { firebase, database as default, auth };